import { HiDotsVertical } from "react-icons/hi";
import PopoverList, { ActionItem } from "./PopoverList";
import { useState } from "react";

type Props = {
    actions: ActionItem[]
    data: unknown
}

function ContextMenu(props: Props) {
    const [openContext, setOpenContext] = useState(false)

    return (
        <div className='flex flex-row justify-center'>
            <div className="relative">
                <button className="p-0 rounded-full bg-transparent text-[#e44131] hover:bg-[#b93527] hover:text-white flex justify-center items-center"
                    style={{ height: '36px', width: '36px' }}
                    onClick={() => setOpenContext(!openContext)}>
                    <HiDotsVertical />
                </button>
                <PopoverList open={openContext} onClose={() => setOpenContext(false)} data={props.data} actions={props.actions} />
            </div>
        </div>
    )
}

export default ContextMenu